import { normalizeApiError, getContextualRequest } from '../../modules/utils/index.js';
import { mapFeatureFlags } from './mapper.js';
import { PATH } from './remote.js';
export default async function getFeatureFlags(client, { clientVersion, ...rest }) {
    const requestBody = { client_version: clientVersion, ...rest };
    try {
        const req = await getContextualRequest(client);
        const res = await req.post(client.context.api.host + PATH).send(requestBody);
        const input = res.body.data;
        return mapFeatureFlags(input);
    }
    catch (err) {
        throw normalizeApiError(err);
    }
}
